import React from 'react';
import { observer } from 'mobx-react-lite';

export const SelectZonePage = observer(() => {
  return <></>;
});
